export const navLinks = [
  { href: '/shop', text: 'SHOP' },
  { href:'/#ceramics', text:'CERAMICS' },
  { href:'/#photography', text:'PHOTO' },
  { href:'/#design', text:'DESIGN' },
  { href:'/#about', text:'ABOUT' },
  { href:'/#contact', text:'CONTACT '}
]

export const footerLinks = navLinks.concat({ href:'/terms-of-use', text: 'TERMS OF USE' });